export default (errors) => {
  if (window.dataLayer?.push) {
    window.dataLayer.push({
      event: 'errorEvent',
      errorEvent: errors,
    });
    
    return 'success';
  }
  return 'fail';
};
